import { FirebaseError } from 'firebase/app'

const genericSignInError = 'Unable to sign in. Check your email and password, or use your usual sign-in method.'
const genericSignUpError = 'Unable to create an account with those details. Try signing in or resetting your password.'

export function authErrorTranslate(error: FirebaseError): string {
  console.log('Error code: ', error.code)

  switch (error.code) {
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return genericSignInError
    case 'auth/email-already-exists':
    case 'auth/email-already-in-use':
      return genericSignUpError
    case 'auth/invalid-email': {
      return 'This email is not valid.'
    }
    case 'auth/invalid-password': {
      return 'The provided password is not valid. Passwords should be at least 6 characters.'
    }
    case 'auth/weak-password': {
      return 'The provided password is not valid. Passwords should be at least 6 characters.'
    }
    case 'auth/too-many-requests': {
      return 'Too many requests. Please wait a few minutes.'
    }
    case 'auth/network-request-failed': {
      return 'Network error. Please try again.'
    }
    case 'auth/user-disabled': {
      return 'Unable to sign in this account. Please contact support.'
    }
    default: {
      console.error('Unexpected auth translate error: ', error)
      return 'Unexpected error.'
    }
  }
}
